import { encryptPayload } from "utils/encrypt_decrypt";
import * as actions from "./actionTypes";
import * as config from "config";

export function downloadGoalSavings(params) {
	const {status, ...rest} = params
	const newParams = !status ? {...rest} : {...params}
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiWalletBaseUrl,
			url:`${config.apiDownloadAllGoalSavings}?${new URLSearchParams(newParams).toString()}`,
			method: "get",
			data: params,
			onStart: actions.DOWNLOAD_GOALS_SAVINGS_START,
			onSuccess: actions.DOWNLOAD_GOALS_SAVINGS_DONE,
			onError: actions.DOWNLOAD_GOALS_SAVINGS_FAILED,
		},
	};
}

export function downloadSavingsCsv(params) {
	let endpointUrl = config.apiGetAllGoalSavings;
    if (Object.keys(params).length > 4){
        endpointUrl = config.apiSearchAndFilterGoalSavings;
    }

	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url:`${endpointUrl}?${new URLSearchParams(params).toString()}`,
			method: "get",
			data: {},
			onStart: actions.DOWNLOAD_GOALS_SAVINGS_START,
			onSuccess: actions.DOWNLOAD_GOALS_SAVINGS_DONE,
			onError: actions.DOWNLOAD_GOALS_SAVINGS_FAILED,
            useEncryption: true,
		},
	};
}

export function searchFilterGoalSavings(params) {
	const {status, ...rest} = params
	const newParams = !status ? {...rest} : {...params}
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url:`${config.apiGetAllGoalSavings}?${new URLSearchParams(newParams).toString()}`,
			method: "get",
			data: params,
			onStart: actions.GET_ALL_GOALS_SAVINGS_START,
			onSuccess: actions.GET_ALL_GOALS_SAVINGS_DONE,
			onError: actions.GET_ALL_GOALS_SAVINGS_FAILED,
		},
	};
}

export function getAllGoalSavings(params) {
	const {status, ...rest} = params
	const newParams = !status ? {...rest} : {...params}
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url:`${config.apiGetAllGoalSavings}?${new URLSearchParams(newParams).toString()}`,
			method: "get",
			data: params,
			onStart: actions.GET_ALL_GOALS_SAVINGS_START,
			onSuccess: actions.GET_ALL_GOALS_SAVINGS_DONE,
			onError: actions.GET_ALL_GOALS_SAVINGS_FAILED,
		},
	};
}

export function getSavingsMetrics() {

	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url: config.apiGetSavingsMetrics,
			method: "get",
			data: {},
			onStart: actions.GET_SAVINGS_METRICS_START,
			onSuccess: actions.GET_SAVINGS_METRICS_DONE,
			onError: actions.GET_SAVINGS_METRICS_FAILED,
		},
	};
}

export function getFlexSavingsMetrics() {
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url: config.apiGetFlexSavingsStats,
			method: "get",
			data: {},
			onStart: actions.GET_SAVINGS_METRICS_START,
			onSuccess: actions.GET_SAVINGS_METRICS_DONE,
			onError: actions.GET_SAVINGS_METRICS_FAILED,
		},
	};
}

export function getSavingsTransactions(payload) {
	const data = encryptPayload(payload);
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url: config.apiGetSingleGoalSavingsTransactions,
			method: "post",
			data,
			onStart: actions.GET_SAVINGS_TRX_START,
			onSuccess: actions.GET_SAVINGS_TRX_DONE,
			onError: actions.GET_SAVINGS_TRX_FAILED,
		},
	};
}

export function getFlexSavingsTransactions(params) {
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url:`${config.apiGetSingleFlexSavingsTransactions}?${new URLSearchParams(params).toString()}`,
			method: "get",
			data: {},
			onStart: actions.GET_SAVINGS_TRX_START,
			onSuccess: actions.GET_SAVINGS_TRX_DONE,
			onError: actions.GET_SAVINGS_TRX_FAILED,
		},
	};
}

export function getSavingsDetails(goalId) {
	const data = encryptPayload({
		goalId,
	});
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url: config.apiGetSingleGoalSavingsDetails,
			method: "post",
			data,
			onStart: actions.GET_SAVINGS_DETAILS_START,
			onSuccess: actions.GET_SAVINGS_DETAILS_DONE,
			onError: actions.GET_SAVINGS_DETAILS_FAILED,
		},
	};
}

export function getFlexSavingsDetails(id) {
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url: `${config.apiGetSingleFlexSavingsDetails}/${id}`,
			method: "get",
			data: {},
			onStart: actions.GET_SAVINGS_DETAILS_START,
			onSuccess: actions.GET_SAVINGS_DETAILS_DONE,
			onError: actions.GET_SAVINGS_DETAILS_FAILED,
		},
	};
}

export function selectSavingsItem(payload) {
    return {
        type: actions.SELECT_SAVINGS_ITEM,
		payload,
    }
}

export function getAllFlexSavings(params) {
	const {status, ...rest} = params
	const newParams = !status ? {...rest} : {...params}
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url:`${config.apiGetAllFlexSavings}?${new URLSearchParams(newParams).toString()}`,
			method: "get",
			data: params,
			onStart: actions.GET_ALL_FLEX_SAVINGS_START,
			onSuccess: actions.GET_ALL_FLEX_SAVINGS_DONE,
			onError: actions.GET_ALL_FLEX_SAVINGS_FAILED,
		},
	};
}

export function searchFilterFlexSavings(params) {
	const {status, ...rest} = params
	const newParams = !status ? {...rest} : {...params}
	return {
		type: config.apiRequestStart,
		payload: {
			baseUrl: config.apiCreditBaseUrl,
			url:`${config.apiGetAllFlexSavings}?${new URLSearchParams(newParams).toString()}`,
			method: "get",
			data: params,
			onStart: actions.GET_ALL_FLEX_SAVINGS_START,
			onSuccess: actions.GET_ALL_FLEX_SAVINGS_DONE,
			onError: actions.GET_ALL_FLEX_SAVINGS_FAILED,
		},
	};
}